var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigherNon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 545.269,
    height: 139.427,
    preserveAspectRatio: "none",
    viewBox: "0 0 545.269 139.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red-strip",
    transform: "translate(-571.862 -87.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    d: "M517,0H25.992c-14.36,0-26,8.408-26,18.779v93.9L-1.14,136.319C5.527,118.5,29.392,83.643,66.993,80.176s323.672-1.445,385.006,0c15.333.482,82.13,3.154,92.13-35.126V18.321C543.035,7.957,531.359,0,517,0Z",
    transform: "translate(573.002 91)",
    fill: "#edbbc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    d: "M491.1,0H-.1C-15.052-1-24,8.179-26.389,18.651l-.611,6.8v108.4c6.642-17.656,30.285-53.825,67.748-57.261s324.476-1.432,385.585,0c15.277.477,81.676,3.257,91.64-34.678V21.182l-.523-2.616C514.126,6.613,504.068-1.123,491.1,0Z",
    transform: "translate(599.002 88)",
    fill: "#f4dfe6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigherNon);
export default __webpack_public_path__ + "static/media/higher_non.70da111987918f65e0f5d3c7250a57cb.svg";
export { ForwardRef as ReactComponent };